import React from "react";
import {
    ModalInfoContent,
    ModalInfoContentBottom,
    WarningInfo,
    WarningInfoContainer
} from "../../../../components/ui/Content";
import {Body1, ChangeIdentityLink, ModalInfoDiscription} from "../../../../components/Font";
import {useTheme} from "styled-components";
import {useAppSelector} from "../../../../app/hooks";
import {InfoModal} from "../../../../ui/Modal/InfoModal";
import {Error} from "../../../../icon/Icon";

export interface PersonalInfoProps {
    onGoEdit(): void
    onGoBack(): void
    onGoEditProfile(): void
}

export const PassportInfo = ({onGoEdit, onGoEditProfile, onGoBack}: PersonalInfoProps) => {
    const Theme = useTheme()
    const {passport, foreign_passport} = useAppSelector(state => state.account)

    const content = () => {
        return <>
            {(passport?.isOutdated || foreign_passport?.isOutdated) &&
                <WarningInfo>
                    <WarningInfoContainer>
                        <div><Error/></div>
                        <Body1 style={{display: 'inline'}}>
                            {`Срок годности вашего паспорта истёк.
                            Измените свои данные здесь и обратитесь в деканат.
                            Если вы поменяли ФИО, не забудьте `}
                            <ChangeIdentityLink onClick={onGoEditProfile} color={Theme.color.indicator}>
                                изменить свои персональные данные
                            </ChangeIdentityLink>
                        </Body1>
                    </WarningInfoContainer>
                </WarningInfo>}
            {passport &&
                <><ModalInfoContent>
                    <ModalInfoDiscription color={Theme.color.secondary}>
                        Гражданство
                    </ModalInfoDiscription>
                    <Body1>
                        {passport.citizenship?.name || '—'}
                    </Body1>
                </ModalInfoContent>

                    <ModalInfoContent>
                        <ModalInfoDiscription
                            className={'passport-description'}
                            color={Theme.color.secondary}>
                            Документ, удостоверяющий личность
                        </ModalInfoDiscription>
                        <Body1>
                            {passport.identityCardType.name || '—'}
                        </Body1>
                    </ModalInfoContent>

                    <ModalInfoContent>
                        <ModalInfoDiscription color={Theme.color.secondary}>
                            Серия
                        </ModalInfoDiscription>
                        <Body1>
                            {passport.series || '—'}
                        </Body1>
                    </ModalInfoContent>


                    <ModalInfoContent>
                        <ModalInfoDiscription color={Theme.color.secondary}>
                            Номер
                        </ModalInfoDiscription>
                        <Body1>
                            {passport.number || '—'}
                        </Body1>
                    </ModalInfoContent>

                    <ModalInfoContent>
                        <ModalInfoDiscription color={Theme.color.secondary}>
                            Кем выдан
                        </ModalInfoDiscription>
                        <Body1>
                            {passport.issued_by || '—'}
                        </Body1>
                    </ModalInfoContent>
                    <ModalInfoContent>
                        <ModalInfoDiscription color={Theme.color.secondary}>
                            Код подразделения
                        </ModalInfoDiscription>
                        <Body1>
                            {passport.department_code || '—'}
                        </Body1>
                    </ModalInfoContent>
                    <ModalInfoContentBottom>
                        <ModalInfoDiscription color={Theme.color.secondary}>
                            Дата выдачи
                        </ModalInfoDiscription>
                        <Body1>
                            {passport.issued_at.format('LL') || '—'}
                        </Body1>
                    </ModalInfoContentBottom>
                </>}

            {foreign_passport &&
                <>
                    <ModalInfoContent>
                        <ModalInfoDiscription color={Theme.color.secondary}>
                            Гражданство
                        </ModalInfoDiscription>
                        <Body1>
                            {foreign_passport.citizenship?.name || '—'}
                        </Body1>
                    </ModalInfoContent>

                    <ModalInfoContent>
                        <ModalInfoDiscription
                            className={'passport-description'}
                            color={Theme.color.secondary}>
                            Документ, удостоверяющий личность
                        </ModalInfoDiscription>
                        <Body1>
                            {foreign_passport.identityCardType.name || '—'}
                        </Body1>
                    </ModalInfoContent>

                    <ModalInfoContent>
                        <ModalInfoDiscription color={Theme.color.secondary}>
                            Номер
                        </ModalInfoDiscription>
                        <Body1>
                            {foreign_passport.number || '—'}
                        </Body1>
                    </ModalInfoContent>

                    <ModalInfoContent>
                        <ModalInfoDiscription color={Theme.color.secondary}>
                            Дата выдачи
                        </ModalInfoDiscription>
                        <Body1>
                            {foreign_passport.issued_at.format('LL') || '—'}
                        </Body1>
                    </ModalInfoContent>

                    <ModalInfoContentBottom>
                        <ModalInfoDiscription
                            className={'passport-description'}
                            color={Theme.color.secondary}>
                            Дата окончания срока действия
                        </ModalInfoDiscription>
                        <Body1>
                            {foreign_passport.expires_at.format('LL') || '—'}
                        </Body1>
                    </ModalInfoContentBottom>
                </>
            }
        </>
    }
    return <InfoModal
        title={'Удостоверение личности'}
        content={content}
        onEdit={onGoEdit}
        onGoBack={onGoBack}
    />
}
